/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Complete helper functions for generating Arduino for
 *     blocks.  This is the entrypoint for Arduino_compressed.js.
 * @suppress {extraRequire}
 */
 'use strict';

 goog.module('Blockly.Arduino.all');
 
 const moduleExports = goog.require('Blockly.Arduino');
 goog.require('Blockly.Arduino.leaphyCommon');
 goog.require('Blockly.Arduino.leaphyOriginal');
 goog.require('Blockly.Arduino.leaphyClick');
 goog.require('Blockly.Arduino.leaphyFlitz');
 goog.require('Blockly.Arduino.leaphyExtra');
 goog.require('Blockly.Arduino.arduino');
 goog.require('Blockly.Arduino.math');
 goog.require('Blockly.Arduino.loops');
 goog.require('Blockly.Arduino.logic');
 goog.require('Blockly.Arduino.variables');
 goog.require('Blockly.Arduino.procedures');
 goog.require('Blockly.Arduino.text');

 exports = moduleExports;
 
 